module.exports = __webpack_public_path__ + "img/ic_exchange_actived.c7d83aa1.svg";